import { render, staticRenderFns } from "./Consensus.vue?vue&type=template&id=15b52a20"
import script from "./Consensus.vue?vue&type=script&lang=js"
export * from "./Consensus.vue?vue&type=script&lang=js"
import style0 from "./Consensus.vue?vue&type=style&index=0&id=15b52a20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports